import React from 'react';
import { motion } from 'framer-motion';

export default function Manifesto() {
  return (
    <section className="py-32 bg-slate-900/30 overflow-hidden relative">
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-full h-full opacity-5 pointer-events-none">
        <div className="text-[30rem] font-black text-white select-none whitespace-nowrap leading-none tracking-tighter italic uppercase">
          MANIFESTO
        </div>
      </div>
      
      <div className="max-w-4xl mx-auto px-4 relative z-10 text-center">
        <motion.div
          initial={{ opacity: 0, scale: 0.95 }}
          whileInView={{ opacity: 1, scale: 1 }}
          viewport={{ once: true }}
          className="space-y-12"
        >
          <p className="text-3xl lg:text-5xl font-black text-white italic uppercase tracking-tighter leading-[1.1]">
            "Documentation shouldn't be a chore. It should be the <span className="text-indigo-400 underline decoration-4 underline-offset-8">automatic byproduct</span> of your craft."
          </p>
          <div className="w-20 h-1 bg-white/10 mx-auto" />
          <p className="text-xl text-slate-400 font-medium leading-relaxed max-w-2xl mx-auto">
            We built DidThis for the makers who are too busy shipping to tweet. For the engineers who find value in the struggle, not just the result. For the 1% who let their work do the talking.
          </p>
        </motion.div>
      </div>
    </section>
  );
}